// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full Page Styling */
.stripe-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--clr-grey-10);
    font-family: var(--ff-primary);
    min-height: 100vh;
    margin: 2rem;
    padding: 20px;
    /* max-width: 90%;  */
    border: 3px solid var(--clr-primary-3);
    color: var(--clr-grey-1);
  }
  
  /* Hero Section */
  .stripe-hero {
    width: 100%;
    max-width: 1100px;
    text-align: center;
    margin-bottom: 3rem;
    padding: 2.5rem 1.5rem;
    background: var(--clr-primary-10);
    border-radius: var(--radius);
    box-shadow: var(--shadow-3);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .stripe-hero-content {
    max-width: 750px;
  }
  
  .stripe-heading {
    font-size: 1.8rem;
    color: var(--clr-primary-1);
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 1rem;
  }
  
  .stripe-subtext {
    font-size: 1rem;
    color: var(--clr-grey-5);
    max-width: 700px;
    margin: 0 auto;
  }
  
  /* Onboarding Section */
  .stripe-container {
    width: 100%;
    max-width: 800px;
    background: var(--clr-white);
    padding: 3rem;
    border-radius: var(--radius);
    box-shadow: var(--shadow-4);
    text-align: center;
  }
  
  /* Loading Spinner */
  .loading-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .loading-spinner {
    font-size: 2.2rem;
    color: var(--clr-primary-5);
    animation: spin 1s linear infinite;
  }
  
  .loading-text {
    font-size: 1rem;
    color: var(--clr-grey-5);
    margin-top: 1rem;
  }
  
  /* Success & Error States */
  .status-box {
    padding: 2rem;
    border-radius: var(--radius);
    text-align: center;
    box-shadow: var(--shadow-2);
  }
  
  .success {
    background: var(--green-light);
    color: var(--green-dark);
  }
  
  .error {
    background: var(--red-light);
    color: var(--red-dark);
  }
  
  .status-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
  }
  
  .success-icon {
    color: var(--green-dark);
  }
  
  .error-icon {
    color: var(--red-dark);
  }
  
  .account-info {
    font-size: 1.1rem;
    margin-bottom: 0.7rem;
  }
  
  /* Buttons */
  .btn-group {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    gap: 1.5rem;
  }
  
  .stripe-btn {
    background: var(--clr-primary-3);
    color: var(--clr-white);
    border: none;
    padding: 1rem 1.8rem;
    font-size: 1rem;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
    font-weight: 600;
  }
  
  .stripe-btn:hover {
    background: var(--clr-primary-4);
  }
  
  .success-btn {
    background: var(--clr-grey-6);
    cursor: not-allowed;
  }
  
  .connect-btn {
    background: var(--clr-primary-3);
  }
  
  .dashboard-btn {
    background: var(--clr-grey-6);
    color: var(--clr-white);
    padding: 1rem 1.8rem;
    font-size: 1rem;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
    font-weight: 600;
    margin-top: 1.5rem;
  }
  
  .dashboard-btn:hover {
    background: var(--clr-grey-7);
  }
  
  /* Icons */
  .icon {
    margin-right: 0.5rem;
  }
  
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Payments/styles/StripeOnboarding.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,8BAA8B;IAC9B,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,sCAAsC;IACtC,wBAAwB;EAC1B;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,iCAAiC;IACjC,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;EAChB;;EAEA,uBAAuB;EACvB;IACE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA,2BAA2B;EAC3B;IACE,aAAa;IACb,4BAA4B;IAC5B,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;IAC9B,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA,YAAY;EACZ;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,gCAAgC;IAChC,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,UAAU;EACV;IACE,oBAAoB;EACtB;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF","sourcesContent":["/* Full Page Styling */\n.stripe-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--clr-grey-10);\n    font-family: var(--ff-primary);\n    min-height: 100vh;\n    margin: 2rem;\n    padding: 20px;\n    /* max-width: 90%;  */\n    border: 3px solid var(--clr-primary-3);\n    color: var(--clr-grey-1);\n  }\n  \n  /* Hero Section */\n  .stripe-hero {\n    width: 100%;\n    max-width: 1100px;\n    text-align: center;\n    margin-bottom: 3rem;\n    padding: 2.5rem 1.5rem;\n    background: var(--clr-primary-10);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-3);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .stripe-hero-content {\n    max-width: 750px;\n  }\n  \n  .stripe-heading {\n    font-size: 1.8rem;\n    color: var(--clr-primary-1);\n    font-weight: 700;\n    text-transform: uppercase;\n    margin-bottom: 1rem;\n  }\n  \n  .stripe-subtext {\n    font-size: 1rem;\n    color: var(--clr-grey-5);\n    max-width: 700px;\n    margin: 0 auto;\n  }\n  \n  /* Onboarding Section */\n  .stripe-container {\n    width: 100%;\n    max-width: 800px;\n    background: var(--clr-white);\n    padding: 3rem;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-4);\n    text-align: center;\n  }\n  \n  /* Loading Spinner */\n  .loading-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .loading-spinner {\n    font-size: 2.2rem;\n    color: var(--clr-primary-5);\n    animation: spin 1s linear infinite;\n  }\n  \n  .loading-text {\n    font-size: 1rem;\n    color: var(--clr-grey-5);\n    margin-top: 1rem;\n  }\n  \n  /* Success & Error States */\n  .status-box {\n    padding: 2rem;\n    border-radius: var(--radius);\n    text-align: center;\n    box-shadow: var(--shadow-2);\n  }\n  \n  .success {\n    background: var(--green-light);\n    color: var(--green-dark);\n  }\n  \n  .error {\n    background: var(--red-light);\n    color: var(--red-dark);\n  }\n  \n  .status-icon {\n    font-size: 3rem;\n    margin-bottom: 1rem;\n  }\n  \n  .success-icon {\n    color: var(--green-dark);\n  }\n  \n  .error-icon {\n    color: var(--red-dark);\n  }\n  \n  .account-info {\n    font-size: 1.1rem;\n    margin-bottom: 0.7rem;\n  }\n  \n  /* Buttons */\n  .btn-group {\n    margin-top: 2rem;\n    display: flex;\n    justify-content: center;\n    gap: 1.5rem;\n  }\n  \n  .stripe-btn {\n    background: var(--clr-primary-3);\n    color: var(--clr-white);\n    border: none;\n    padding: 1rem 1.8rem;\n    font-size: 1rem;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: var(--transition);\n    font-weight: 600;\n  }\n  \n  .stripe-btn:hover {\n    background: var(--clr-primary-4);\n  }\n  \n  .success-btn {\n    background: var(--clr-grey-6);\n    cursor: not-allowed;\n  }\n  \n  .connect-btn {\n    background: var(--clr-primary-3);\n  }\n  \n  .dashboard-btn {\n    background: var(--clr-grey-6);\n    color: var(--clr-white);\n    padding: 1rem 1.8rem;\n    font-size: 1rem;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: var(--transition);\n    font-weight: 600;\n    margin-top: 1.5rem;\n  }\n  \n  .dashboard-btn:hover {\n    background: var(--clr-grey-7);\n  }\n  \n  /* Icons */\n  .icon {\n    margin-right: 0.5rem;\n  }\n  \n  @keyframes spin {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
